import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../..';
import { saveComment, searchUsers, addUser, removeUser, clearUsers } from '../../comments.actions';
import { CommentComponent, CommentComponentProperties } from './comment.component';
import { CommentViewModel, CommentType } from '@models/Comment';
import { ProfileViewModel } from '@models/Auth';
import { actions } from 'react-redux-form';

import { OptionsViewModel } from '@models/common.models';
import FormNames from '@constants/FormNames.enum';

interface CommentProperties {
  saveCallback?: Function;
  entityId: number;
  commentType: CommentType;
  commentId?: number;
  comment?: CommentViewModel;
  hideSave?: boolean;
  isActionComplete?: boolean;
  oldCommentText?: string;
  showCallerNameField?: boolean;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState, ownProps: CommentProperties): Partial<CommentComponentProperties> {
  return {
    message: state.comment.message,
    commentId: ownProps.commentId,
    comment: ownProps.comment,
    usersToAction: state.comment.usersToAction,
    hideSave: ownProps.hideSave,
    isActionComplete: ownProps.isActionComplete,
    oldCommentText: ownProps.oldCommentText
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: CommentProperties
): Partial<CommentComponentProperties> {
  return {
    onSaveClick: (values: CommentViewModel, usersToAction: Array<OptionsViewModel>) => {
      dispatch(clearUsers());
      dispatch(saveComment(ownProps.entityId, ownProps.commentType, values, usersToAction, ownProps.saveCallback));
    },
    userGroupLookup: (value: string, id?: number) => {
      return searchUsers(value, id);
    },
    loadComment: (comment: CommentViewModel) => {
      dispatch(actions.change(FormNames.CommentForm, comment));
    },
    addUser: (user: ProfileViewModel) => {
      dispatch(addUser(user));
    },
    removeUser: (userEmail: string) => {
      dispatch(removeUser(userEmail));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const Comment = connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentComponent);



// WEBPACK FOOTER //
// ./src/comments/_components/comment/comment.container.ts